const doc = [({"en":({"js":({"merfoto":({"orders":({"order":"Orders"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;